import { useEffect } from 'react';
import { RecordingControls } from './components/RecordingControls';
import { TranscriptDisplay } from './components/TranscriptDisplay';
import { SummaryDisplay } from './components/SummaryDisplay';
import { useRecorder } from './hooks/useRecorder';
import { useUploader } from './hooks/useUploader';
import { useTranscription } from './hooks/useTranscription';
import { useSummary } from './hooks/useSummary';

function App() {
  const recorder = useRecorder();
  const uploader = useUploader();
  const transcription = useTranscription(recorder.state.sessionId);
  const summary = useSummary();

  // Update pending upload count when session changes
  useEffect(() => {
    if (recorder.state.sessionId) {
      uploader.updatePendingCount(recorder.state.sessionId);
    }
  }, [recorder.state.sessionId]);

  // Handle stop recording
  const handleStop = async () => {
    const sessionId = await recorder.stopRecording();

    if (sessionId) {
      // Generate summary
      await summary.generate(sessionId);
    }
  };

  // Reset when starting new recording
  const handleStart = async (...args: Parameters<typeof recorder.startRecording>) => {
    transcription.reset();
    summary.reset();
    await recorder.startRecording(...args);
  };

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '1200px', margin: '0 auto' }}>
      <header
        style={{
          padding: '20px',
          backgroundColor: '#007bff',
          color: 'white',
          textAlign: 'center',
        }}
      >
        <h1>Audio2Text - 长录音稳定转写</h1>
        <p style={{ margin: '5px 0', fontSize: '14px' }}>
          支持 3-5 小时录音 | 多 Provider 可切换 | 断网续传
        </p>
      </header>

      <main>
        <RecordingControls
          state={recorder.state}
          onStart={handleStart}
          onPause={recorder.pauseRecording}
          onResume={recorder.resumeRecording}
          onStop={handleStop}
        />

        {recorder.state.sessionId && (
          <TranscriptDisplay
            segments={transcription.getOrderedSegments()}
            pendingUploadCount={uploader.pendingCount}
          />
        )}

        <SummaryDisplay
          summary={summary.summary}
          isGenerating={summary.isGenerating}
          error={summary.error}
        />
      </main>

      <footer
        style={{
          padding: '20px',
          textAlign: 'center',
          borderTop: '1px solid #ddd',
          marginTop: '40px',
          color: '#6c757d',
          fontSize: '14px',
        }}
      >
        <p>Audio2Text V1 - Powered by Cloudflare Workers</p>
        <p>支持 Provider: Baidu | Doubao | Tongyi</p>
      </footer>
    </div>
  );
}

export default App;
